import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { LightboxModule } from 'ngx-lightbox';
import { GetImageSrcPipe } from 'app/pipes/get-image-src.pipe';
import { SearchFormModule } from '../components/search-form/search-form.module';
import { FuseSidebarModule } from '@fuse/components';
import { TrafficLightModule } from './traffic-light/traffic-light.module';
import { PrivateBasketComponent } from 'app/main/properties/index/private-basket/private-basket.component';
import { RouterModule } from '@angular/router';
import { RejectAccountModule } from './reject-account/reject-account.module';
import { PropertyBookingsModule } from '../property-bookings/property-bookings.module';
import { IndexMenuButtonModule } from '../components/index-menu-button/index-menu-button.module';
import { PropertiesDetailsViewModule } from './properties-details-view/properties-details-view.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { VirtualTourCodeComponent } from './virtual-tour-code/virtual-tour-code.component';
import { ClipboardModule } from 'ngx-clipboard';
import { AllPropertiesShowOnMapModule } from 'app/components/all-properties-show-on-map/all-properties-show-on-map.module';
import { PropertyDuplicationsModule } from './property-duplications/property-duplications.module';
import { PropertyReservationModule } from './property-reservation/property-reservation.module';
import { OverviewModule } from '../view/overview/overview.module';
import { ClientRegistrationRequestModule } from './client-registration-request/client-registration-request.module';
import { ShowReasonDialogComponent } from './show-reason-dialog/show-reason-dialog.component';

@NgModule({
    declarations: [IndexComponent, PrivateBasketComponent, VirtualTourCodeComponent, ShowReasonDialogComponent],
    imports: [
        CommonModule,
        RouterModule,
        FuseSharedModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatOptionModule,
        MatSelectModule,
        MatPaginatorModule,
        MatTableModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatTooltipModule,
        MatMenuModule,
        FuseSidebarModule,
        LightboxModule,
        SearchFormModule,
        TrafficLightModule,
        MatDialogModule,
        MatCheckboxModule,
        MatToolbarModule,
        RejectAccountModule,
        PropertyBookingsModule,
        IndexMenuButtonModule,
        PropertiesDetailsViewModule,
        MatCardModule,
        ClipboardModule,
        AllPropertiesShowOnMapModule,
        PropertyDuplicationsModule,
        PropertyReservationModule,
        OverviewModule,
        ClientRegistrationRequestModule
    ],
    providers: [
        GetImageSrcPipe
    ],
    exports: [IndexComponent]
})
export class IndexModule { }
